import {AfterViewInit, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-yandex-map',
  imports: [],
  templateUrl: './yandex-map.component.html',
  styleUrl: './yandex-map.component.scss'
})
export class YandexMapComponent implements AfterViewInit, OnInit{
  constructor() { }

  width: number = 500;
  height: number = 500;

  ngOnInit() {
      if (window.innerWidth < 756) {
        this.width = 324;
        this.height = 324;
      }

  }

  ngAfterViewInit(): void {
    // Инициализация карты после загрузки представления
    (window as any).ymaps.ready(this.initMap);
  }

  initMap() {
    const myMap = new (window as any).ymaps.Map("map", {
      center: [55.420722, 37.524510], // Координаты центра карты (Москва)
      zoom: 15 // Уровень масштабирования
    });

    const base = new (window as any).ymaps.Placemark([55.420127, 37.516063], {
      hintContent: 'ул. Кирова, 63 А, Подольск, Московская обл., 142117', // Подсказка при наведении
      balloonContent: 'ул. Кирова, 63 А, Подольск, Московская обл., 142117' // Содержимое балуна
    }, {
      iconLayout: 'default#image',
      iconImageHref: 'app/assets/icons/base.svg', // Путь к вашей иконке (положите иконку в папку assets)
      iconImageSize: [80, 80], // Размер иконки
      iconImageOffset: [-40, -40] // Смещение иконки (центрирование)
    });
    const parking = new (window as any).ymaps.Placemark([55.420123, 37.517916], {
      hintContent: 'Парковка', // Подсказка при наведении
      balloonContent: 'Парковка' // Содержимое балуна
    }, {
      iconLayout: 'default#image',
      iconImageHref: 'app/assets/icons/parking.svg', // Путь к вашей иконке (положите иконку в папку assets)
      iconImageSize: [40, 40], // Размер иконки
      iconImageOffset: [-20, -20] // Смещение иконки (центрирование)
    });
    const hotel = new (window as any).ymaps.Placemark([55.419580, 37.533230], {
      hintContent: 'Гостиница', // Подсказка при наведении
      balloonContent: 'Гостиница' // Содержимое балуна
    }, {
      iconLayout: 'default#image',
      iconImageHref: 'app/assets/icons/hotel.svg', // Путь к вашей иконке (положите иконку в папку assets)
      iconImageSize: [40, 40], // Размер иконки
      iconImageOffset: [-20, -20] // Смещение иконки (центрирование)
    });

    myMap.geoObjects.add(base);
    myMap.geoObjects.add(parking);
    myMap.geoObjects.add(hotel);
  }
}
